import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/manageServer";

// Initial state for the banner slice
const initialState: any = {
  isLoading: false,
  error: null,
  banners: [],
  banner: null,
};

// Create banner slice
const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getBannersSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.banners = action.payload;
    },
    getBannerSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.banner = action.payload;
    },
  },
});

export default bannerSlice.reducer;

const { actions } = bannerSlice;

export function getBanners() {
  return async (dispatch: any) => {
    try {
      dispatch(actions.startLoading());
      const response = await axiosInstance.get("/ProductPromotion/filter?active=true");
      // console.log("roshaniiiii", response.data);
      dispatch(actions.getBannersSuccess(response.data?.records));
    } catch (error) {
      console.log("errt", error);
      dispatch(actions.hasError(error));
    }
  };
}

export function fetchBannerById(id: number) {
  return async (dispatch: any, getState: () => any) => {
    dispatch(actions.startLoading());
    try {
      const response = await axiosInstance.get(`ProductPromotion/${id}`);
      dispatch(actions.getBannerSuccess(response.data));
    } catch (error) {
      console.log("errt", error);
      dispatch(actions.hasError(error));
    }
  };
}

// export function fetchBannerById() {
//   debugger
//   return async (dispatch: Dispatch) => {
//     dispatch(actions.startLoading());
//     try {
//       const response = await axiosInstance.get(`banner/6`);
//       console.log("thusibject",response)
//       dispatch(actions.getBannerSuccess(response.data));
//     } catch (error) {
//       console.log("Error fetching similar banner data:", error);
//       dispatch(actions.hasError(error));
//     }
//   };
// }
// Thunk function to get active banners
// export function getBanners() {
//   return async () => {
//   const { dispatch } = store;
//   console.log(
//     "kkkkkkkllllllllllllllllllllllllllkkkkkkk"
//     )
//     dispatch(actions.startLoading());
//     try {
//       const response = await axiosInstance.get(
//         /banners?isActive=true
//         //      {
//         //   params: { isActive: true },
//         // }
//       );

//       // Filter to include only banners where isActive is true
//       // const activeBanners = response.data
//       //   .filter((banner: any) => banner.isActive)
//       //   .map((banner: any) => ({
//       //     id: banner.id,
//       //     imageUrl: banner.imageUrl,
//       //   }));
//       console.log("response?.datathussisis", response?.data);
//       dispatch(actions.getBannersSuccess(response?.data));
//     } catch (error) {
//       console.error("Error fetching banners:", error);
//       dispatch(actions.hasError(error));
//     }
//   };
// }/         `/banners?isActive=true`
//         //      {
//         //   params: { isActive: true },
//         // }
//       );

//       // Filter to include only banners where isActive is true
//       // const activeBanners = response.data
//       //   .filter((banner: any) => banner.isActive)
//       //   .map((banner: any) => ({
//       //     id: banner.id,
//       //     imageUrl: banner.imageUrl,
//       //   }));
//       console.log("response?.datathussisis", response?.data);
//       dispatch(actions.getBannersSuccess(response?.data));
//     } catch (error) {
//       console.error("Error fetching banners:", error);
//       dispatch(actions.hasError(error));
//     }
//   };
// }
